import { Navigate } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { Layout } from './Layout';

export const AuthCheck = () => {
    const { isSuccess, isFetching } = useUser();

    if (isFetching) return null;

    if (isSuccess) return <Layout />;

    return <Navigate to="/login" />;
};
